import { DateTime } from "luxon";
import moment from "moment";
import renderHTML from "react-render-html";
import {
    Audio2, Camera, ChatAudioRecorderDark, Contact, DocumentIcon,
    Gif, IconMissedCallAudio, IconMissedCallVideo, Location, Sticker, VideoIcon2, StarBlue, StarGray
} from "../../../../assets/images";
import _get from "lodash/get";
import Cryptlib from "cryptlib";
import CryptoJS from "crypto-js";
import { GIF_FORMAT, GIF_STICKER_FORMATS, STICKER_FORMAT } from "../../../../const/Constants";
import { encryptKey } from "../../../../helper/ApiUrl";
import store from "../../../../store";

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const getlabel = (current_datetime) => {
    const today = moment();
    const dateObject = new Date(current_datetime?.replace(/ /g, "T"));
    const diffenceDay = today.diff(current_datetime, 'days');
    if (diffenceDay === 0) {
        return 'Today';
    } else if (diffenceDay === 1) {
        return 'Yesterday';
    } else if (diffenceDay > 1 && diffenceDay <= 6) {
        return DateTime.fromJSDate(dateObject).toFormat('cccc');
    } else if (dateObject.getFullYear() === new Date().getFullYear()) {
        return `${dateObject.getDate()} ${months[dateObject.getMonth()]}`;
    }
    return `${dateObject.getDate()} ${months[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
};
export const convertDateFormat = (dateString) => {
    return getlabel(dateString);
};
export const millisToMinutesAndSeconds = (millis) => {
    let minutes = Math.floor(millis / 60000);
    let seconds = parseInt((millis % 60000) / 1000);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
};
export const isGifStickerImage = (message_type) => {
    if (!message_type) return false;
    return GIF_STICKER_FORMATS.includes(message_type);
};
export function getExtension(name = "") {
    if (!name) return "";
    const lastDotIndex = name.lastIndexOf(".");
    if (lastDotIndex === -1) {
        return "";
    }
    const lastDot = name.substring(lastDotIndex + 1, name.length);
    return "." + lastDot;
};
export const calWidthHeightRatio = (originalWidth, originalHeight, maxDimension) => {
    const newDimension = {
        width: originalWidth,
        height: originalHeight
    }

    if (originalWidth >= originalHeight && originalWidth >= maxDimension) {
        newDimension.width = maxDimension;
        newDimension.height = Math.round((originalHeight / originalWidth) * maxDimension);
    }
    else if (originalHeight >= originalWidth && originalHeight >= maxDimension) {
        newDimension.height = maxDimension;
        newDimension.width = Math.round((originalWidth / originalHeight) * maxDimension);
    }
    return newDimension;
}
export const isObjectEmpty = (obj) => {
    return !obj || Object.keys(obj).length === 0;
};
function formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
}

export const formatChatTime = (date, type) => {
    if (type === "recent-chat") {
        return formatAMPM(date);
    }
    const dateCurrent = DateTime.fromMillis(Date.now());
    const dateMessage = DateTime.fromJSDate(date);
    const datesDiff = dateCurrent.diff(dateMessage, "minutes").toObject().minutes;

    if (!datesDiff) {
        return null; /** change ? to null */
    }

    const diffRounded = Math.round(datesDiff);

    if (diffRounded === 0) {
        return "Now";
    } else if (diffRounded === 1) {
        return `${diffRounded} min ago`;
    } else if (diffRounded < 60) {
        return `${diffRounded} mins ago`;
    } else {
        return dateMessage.toFormat(TIME_FORMAT);
    }
};

export const formatChatDate = (date) => {
    const dateCurrent = DateTime.fromMillis(Date.now());
    const dateMessage = DateTime.fromJSDate(date);
    const datesDiff = dateCurrent.diff(dateMessage, "days").toObject().days;
    if (!datesDiff) {
        return null; /** change ? to null */
    }
    const diffRounded = Math.round(datesDiff);

    if (diffRounded === 0) {
        return "Today";
    } else if (diffRounded === 1) {
        return "Yesterday";
    } else if (diffRounded > 1 && diffRounded <= 6) {
        return DateTime.fromJSDate(date).toFormat("cccc");
    } else {
        const isCurrentYear = date.getFullYear() === new Date().getFullYear()
        return DateTime.fromJSDate(date).toFormat(isCurrentYear ? "d MMM" : "d MMM yyyy");
    }
};

export const formatChatDateTime = (date, type) => {
    const timeFormatted = formatChatTime(date, type);
    const dayFormatted = formatChatDate(date);

    if (type === "recent-chat") {
        if (dayFormatted === "Today") {
            return timeFormatted;
        }
        return dayFormatted;
    } else {
        if (timeFormatted.match(/Now|mins? ago/i)) {
            return timeFormatted;
        }
        return dayFormatted;
    }
};

export const convertUTCTOLocalTimeStamp = (date) => {
    date = new Date(date.replace(/-/g, "/"));
    let newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    return newDate;
};

export const handleTimeStamp = (time) => {
    return formatChatDateTime(convertUTCTOLocalTimeStamp(time), "recent-chat");
}
export const handleMentionedUser = (text = "", mentionedUsersIds, mentionedMe, mentionedClass = "") => {
    let UserId = mentionedUsersIds;
    if (!text) return "";
    const pattern = /@\[\?\]/gi;
    if (mentionedUsersIds !== undefined && text !== "" && text.match(pattern) !== null && text.match(pattern).length > 0 && text.match(pattern) !== undefined) {
        let content = text;
        let particiantData = []
        particiantData = content.match(pattern);
        particiantData.map((uidPattern) => {
            const uid = uidPattern
            for (let i = 0; i < UserId.length; i++) {
                const mentionedUserId = UserId[i];
                //   let rosterData = getUserDetailsForMention(mentionedUserId);
                let rosterData = "";
                let displayName = rosterData.displayName;
                content = `${content.replace(uid, `<button data-mentioned="${mentionedUserId}" 
        class='${mentionedClass} ${mentionedMe === mentionedUserId ? " tagged  " : " "} mentioned'><b>@</b> <i>${displayName !== undefined ? displayName : []}</i> </button> `)}`;
            }
        });
        return content;
    }
    else {
        return text;
    }
}
export const replaceHtmlentity = (text) => {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

export const getFormattedRecentChatText = (text) => {
    if (!text) return "";

    const formattedText = replaceHtmlentity(text).replace(/\n/g, "&nbsp;&nbsp;");

    return formattedText.length > 40
        ? formattedText.slice(0, 40) + "..."
        : formattedText;
};

export function capitalizeFirstLetter(string) {
    if (!string) return null;
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export const formatMessage = (msgBody, msgType) => {
    let message = msgBody?.message;
    // const { item: { recent: { chatType } } = {} } = this.props;
    if (["image", "video", "audio", "file", "contact", "location", ...GIF_STICKER_FORMATS].indexOf(msgType) > -1) {
        // Media type icon mapping
        const icons = {
            image: (
                <i className="chat-camera">
                    <Camera />
                </i>
            ),
            video: (
                <i className="chat-video">
                    <VideoIcon2 />
                </i>
            ),
            audio: (
                <i style={{ width: '14px', height: '14px' }} className={` ${_get(msgBody, "media.audioType", "") !== "recording" ? "audio" : "mic"} chat-audio`}>
                    {_get(msgBody, "media.audioType", "") !== "recording" ? <Audio2 /> : <ChatAudioRecorderDark />}
                </i>
            ),
            file: (
                <i className="chat-docu">
                    <DocumentIcon />
                </i>
            ),
            contact: (
                <i className="chat-contact">
                    <Contact />
                </i>
            ),
            location: (
                <i className="chat-location">
                    <Location />
                </i>
            ),
            missedCallAudio: (
                <i className="chat-missedcall">
                    <IconMissedCallAudio />
                </i>
            ),
            missedCallVideo: (
                <i className="chat-missedcall">
                    <IconMissedCallVideo />
                </i>
            ),
            [GIF_FORMAT]: (
                <i className="chat-gif">
                    <Gif />
                </i>
            ),
            [STICKER_FORMAT]: (
                <i className="chat-sticker">
                    <Sticker />
                </i>
            ),
        };
        if (msgBody && typeof msgBody === "object") {
            if (msgType === "image") {
                message = "Photo";
            } else {
                message = capitalizeFirstLetter(msgType)
            }
            if (msgBody?.media?.caption) {
                message = msgBody?.media?.caption;
                const regex = /<span\s[^>]*>@([^<]+)<\/span>/g;
                message = message.replace(regex, "@[?]");
            }
        }
        message = renderHTML(handleMentionedUser(getFormattedRecentChatText(message), msgBody?.mentionedUsersIds || [], false));
        return (
            <>
                {icons[msgType] || ""} {message}
            </>
        );
    }
    return renderHTML(handleMentionedUser(getFormattedRecentChatText(message), msgBody?.mentionedUsersIds ? msgBody?.mentionedUsersIds : [], false));
};
export const getStatusBackgroundColor = (status) => {
    switch (status) {
        case 2: return "#66e69a"; // Sent - Green
        case 1: return "#ffc400"; // Not Sent - Yellow
        case 0: return "#dfdfdf"; // Offline - Gray
        default: return "transparent";
    }
};
export const getFormattedText = (text) => {
    if (!text) return "";
    return replaceHtmlentity(text);
};
export const captionLink = (text, mentionedUserId, userId, chatType) => {
    if (!text) return "";
    const regex = /<span\s[^>]*>@([^<]+)<\/span>/g;
    text = text.replace(regex, "@[?]");
    return renderHTML(handleMentionedUser(getFormattedText(text), mentionedUserId, userId, null, chatType));
};
export function convertWordArrayToUint8Array(wordArray) {
  const len = wordArray.sigBytes;
  const u8 = new Uint8Array(len);
  let offset = 0;
  for (let i = 0; i < wordArray.words.length; i++) {
    const word = wordArray.words[i];
    u8[offset++] = (word >> 24) & 0xff;
    u8[offset++] = (word >> 16) & 0xff;
    u8[offset++] = (word >> 8) & 0xff;
    u8[offset++] = word & 0xff;
  }
  return u8.slice(0, len);
}
const getMimeFromExtension = (filename) => {
  const ext = filename?.split(".").pop()?.toLowerCase() || "";

  const mimeTypes = {
    // Images
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
    gif: "image/gif",

    // Video
    mp4: "video/mp4",
    mov: "video/quicktime",
    webm: "video/webm",

    // Audio
    mp3: "audio/mpeg",
    wav: "audio/wav",
    m4a: "audio/mp4",
    aac: "audio/aac",
    ogg: "audio/ogg",

    // Documents & others
    pdf: "application/pdf",
    txt: "text/plain",
    zip: "application/zip",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  };

  return mimeTypes[ext] || "application/octet-stream";
};
export const fetchBlobFromMediaUrl = async (mediaUrl) => {
  const response = await fetch(mediaUrl);
  if (!response.ok) {
    throw new Error("Failed to download media");
  }
  return await response.blob();
};
export const decryptMediaFile = (fileBlob, encryptionKey, autoDownload = true, fileName = "media") => {
  return new Promise((resolve, reject) => {
    if (!encryptKey) {
      return reject("❌ Decryption failed: REACT_APP_ENCRYPT_KEY is not configured. Restart the dev server after updating .env.");
    }
    if (!encryptionKey) {
      return reject("❌ Decryption failed: Missing file encryption key (file_key).");
    }
    try {
      const reader = new FileReader();

      reader.onload = () => {
        try {
          const arrayBuffer = reader.result;
          const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);

          const iv = CryptoJS.enc.Utf8.parse(encryptKey.substring(0, 16));
          let decryptKey = Cryptlib.getHashSha256(encryptionKey, 32);
          decryptKey = CryptoJS.enc.Utf8.parse(decryptKey);
          const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: wordArray },
            decryptKey,
            { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
          );

          if (!decrypted || decrypted.sigBytes === 0) {
            return reject("❌ Wrong encryption key or corrupted file.");
          }

          const decryptedBytes = convertWordArrayToUint8Array(decrypted);
          const mimeType = getMimeFromExtension(fileName);
          const finalBlob = new Blob([decryptedBytes], { type: mimeType });
          const blobUrl = URL.createObjectURL(finalBlob);
          if (autoDownload) {
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          resolve({ blobUrl, blob: finalBlob });

        } catch (err) {
          reject("❌ Decryption failed: " + err.message);
        }
      };

      reader.readAsArrayBuffer(fileBlob);

    } catch (error) {
      reject(error);
    }
  });
};
export const chatMediaDownloadMethod = async (url, decryptDataNeeded) => {
  try {
    const downloadedBlob = await fetchBlobFromMediaUrl(url);
    const decryptedFile = await decryptMediaFile(
      downloadedBlob,
      decryptDataNeeded.fileKey,
      true,
      decryptDataNeeded.fileName
    );
    store.dispatch({ type: 'REMOVE_DOWNLOADING_MESSAGE', msgId: decryptDataNeeded.fileToken });
    return decryptedFile;

  } catch (err) {
    console.error("Media download/decrypt failed:", err);
  }
};

export const getThumbBase64URL = (thumb) => {
  if (thumb !== "" && thumb !== null) {
    return `data:image/png;base64,${thumb}`
  } else {
        // eslint-disable-next-line max-len
    return `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAACqCAYAAADMWNgmAAAABHNCSVQICAgIfAhkiAAADxBJREFUeF7tnfuOFEUUh0tBQOQWNggEEOR+SSCIBqKLxoRsjE/gk/gQvog+ASEbEsIlZDfAH5Cg3EQQjEHl4gUISsD5VXI2xezszDDV01NV/XWycdnpqj7nO9XfVlWPO2+8fPlyjXPum9bXROtrdeuLAwIQgEBuBO61Ap5sfX39Rktq37a++Sq3DIgXAhCAQAcC30lqj1ovLAcPBCAAgQII/CmpvSwgEVKAAAQg4AkgNQYCBCBQFAGkVlQ5SQYCEEBqjAEIQKAoAkitqHKSDAQggNQYAxCAQFEEkFpR5SQZCEAAqTEGIACBogggtaLKSTIQgABSYwxAAAJFEUBqRZWTZCAAAaTGGIAABIoigNSKKifJQAACSI0xAAEIFEUAqRVVTpKBAASQGmMAAhAoigBSK6qcJAMBCCA1xgAEIFAUAaRWVDlJBgIQQGqMAQhAoCgCSK2ocpIMBCCA1BgDEIBAUQSQWlHlJBkIQACpMQYgAIGiCCC1ospJMhCAAFJjDEAAAkURQGpFlZNkIAABpMYYgAAEiiKA1IoqJ8lAAAJIjTEAAQgURQCpFVVOkoEABJAaY8ATuH79urt79657+vRpEkT27t3r1q9fn0QsBJEXAaSWV72GEu3U1JR78ODBUPqO6RSxxdBrbluk1tza+8y///57d+vWLf/9unXr/OxobGxsZFQ0Y9SXHYhtZKXI9sJILdvSxQf+/PlzNzk56TvatGmT2717d3ynkT20S03dIbZIqA1rjtQaVvAw3fv377vp6Wn/o4mJCTd//vyR0+gkNcQ28rJkFQBSy6pc1QZrUlu6dKk7fPhwtZ0P2NtcUkNsAwJtYDOk1sCiW8omtZUrV7pDhw4lQaKb1BBbEiVKPgiklnyJhhdgjlJDbMMbD6X0jNRKqeQAeeQqNcQ2QLEb1ASpNajY7anmLDXE1uCB2yN1pNbgsZG71BBbgwdvl9SRWoPHRQlSQ2wNHsBzpI7UGjwmSpEaYmvwIO6QOlJr8HgoSWqIrcEDuS11pNbgsVCa1BBbgwdzkDpSa/A4KFFqKuf4+LhbtmxZgyvb7NSRWoPrn6LUFNOgfwbJ/h7cwYMHR/qXRho8pJJIHaklUYbRBJGi1GJI2N+FQ2oxFPNvi9Tyr+HAGSC1gdHRMGECSC3h4gw7NKQ2bML0PwoCSG0U1BO5JlJLpBCEUSkBpFYpzrw6Q2p51Yto+yOA1PrjVORZSK3IsjY+KaTW4CGA1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xD4XAaTW4LGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xM7TT8bALAJIjUFRIgFmaiVWtc+ckFqfoDgtKwJILatyVRssUquWJ72lQQCppVGHkUSB1EaCnYsOmQBSGzLglLtHailXh9gGJYDUBiVXQDukVkARSWEWAaTW4EGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xD4XAaTW4LGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xM7TT8bALAJIjUFRIgFmaiVWtc+ckFqfoDgtKwJILatyVRssUquWJ72lQQCppVGHkUSB1EaCnYsOmQBSGzLglLtHailXh9gGJYDUBiVXQDukVkARSWEWAaTW4EGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMublJbf78+W5iYiLnVHzsk5OT7vnz5+7gwYNubGws+3xIYDACSG0wbkW0+uuvv9yZM2d8LrmLwAStXD7//HP39ttvF1Ejknh9Akjt9ZkV1eL06dPu77//dpqtHTp0yC1btiy7/CTnqakpP0tbunSpO3z4cHY5EHB1BJBadSyz7CmcrSmBlStXZpfHgwcPZmIeHx/PUszZQU84YKSWcHHqCk1Lt0uXLrmnT5/WdcnKr6Pl5t69e9lLq5xsfh0itfxqNpSItXST3DRzy+3QklkPBrSE5oAAUmMMQAACRRFAakWVk2QgAAGkxhiAAASKIoDUiionyUAAAkiNMQABCBRFAKkVVU6SgQAEkBpjAAIQKIoAUiuqnCQDAQggNcYABCBQFAGkVlQ5SQYCEEBqjAEIQKAoAkitqHKSDAQggNQYAxCAQFEEkFpR5SQZCEAAqTEGIACBogggtaLKSTIQgABSYwy8NoHffvvNXblyxe3cudO9++67r91+1A2uXbvm/vjjD7d//34fiv445pIlS9yKFSu6hmZ5r1mzxm3fvr3juXfv3nULFizIksuo61LV9ZFaVST77Ofo0aP+zPZPPLp48aL75Zdf3K5du9z777/fZ2+jOe2nn35yP/zwg9u6deucN/doIuvvqhcuXHC///67++CDD9y///7r/5T56tWr3YEDB7p2IGH1Olf11Z8WV305RkMAqdXM3aSmmcGnn346c/WcpFYzsqFerh9RWQD9nIvUhlquvjpHan1hqu4kk5p6DGc67VLTh6BoVqClkQ799t+zZ0/HZc2pU6fcP//842cbmoG8ePHilfPtZtSySJ9FsHDhQj+T0Izrxx9/9LOVN998023evNnPvDSTuXfv3iuzxsuXL7vbt2/7mBVbOKtsj1XC/uijj3wMx48f9/EfOXLE//fs2bPu0aNH/kNS1q9f72PQrG/jxo0+v/DQcu/GjRv+fB3Wr74/ceLErBnRsWPHfG76qD997F+ntorJeImBfeiMzdQsl4cPH3qOYqZYtcw2jopDh5jrWLdundu3b5//vl1qtmS1c/uZEVY32prZE1Krue426HVZ3UAff/yx38tpl5pu2mfPnnnRvPXWW+7WrVuvnB+GbTepxLRjxw735MkTLyD9+4svvpi5GU1cixcv9s0lTd3k27Ztcz///LOXh6SleM6fP+8/zEQfcqxD11C/n332mdOeVCg1u77EpFhv3rzpPwRFIpuenvbisOW2xCNZmAgs7w8//HCWsCVESVgM/vvvP5+TzXBNjsbPhGP9dmvbTWoWr/rRB7pcvXrVx/vll1/OcBQPsdE5169f93UxKYdS089Pnjzp+aku+lAbcQu51jz8GnE5pFZzmW3Qa1Yicdj+Syg1iaF976bb0sdu0nDmZ7Mt/UwSU3/hzWRSMJnoBpRITRrhDMtek+wkkTDWd955x+dhrwmnXVszHIlQMybtFdq5Oseuo9g1U/zkk09mfaq6Xlu+fPnMLEjxKRYJ8s6dO75fy9muafl0a3vu3Dk/y+o0U1M/EqliV23CWavVJZyJGhvN6CTxUGo2uw1noZaDJMkxHAJIbThc5+w1HPQmB/3G12GzH/uN3v7QYK79mnDmoRtRRyhBLXnaJRku1ayN9aMbLpTE48ePX3kwEErNZoWhUMNZk25oCVQxLFq0yMto1apVfnmr6ygOzYgky15HmKfOlSBMpvpeh5aelk/YX9i2m9TaY+j1y0bnh32Hy+L22aTOtf5s+d0rZ15/fQJI7fWZRbVoF5PdEJpFaZkmkdUhtXBvrz0hzWC0J6UZmKSkWY32mLT0lDDCG91i7QTF9o90o8+bN8/vd2lJrbeCWN9aUnbaTzMB6NPX2z9k2ZaykoauL5Hp+3BvSzHO1bab1LTHJ/HaHpjlpbp0mkF3k5rVthObHJ5yRw30ETZGajXDb5ea9rGmpqb8vo2OuW6eKpaf4SZ1+wa+YVA89n4tnaNllWZj4WwqlJr2usJlYIjT+rK3UGifTbM0barbTDHcVwzbat9O/UpUenjRvsGvf9s5ilfXsqVnr7ZzSW3Lli1ejupv9+7ds/Y6TWrhWzZs+amfSa7hTM3252zfz/IzSXeaUdY8HIu8HFKruaydlpC292JS0/vUbO9Fyzp7UKBZjt5b1f6G13BGICnaklBC0l5V+xO+cBmkG/i9996b2fvqtDem8+d6Uqs3omozXFI2IetBgWY6Jhl7wql+bNllSzOTQfsNHgpL8SkHLc912EzNhKKfhf30attLauKm2aQ4KpcwNy3jdRi3bg8KwqfO6k+/APS0WUenPcSah2Kxl0NqNZe2176YLUs6vU1CTwH1Noj2w6SmWc2vv/7qb0JtZtv5c83yNOPSW0DsLR1r1671S0GbqentCFom6qmpLT1DIVqsnd56sWHDhpk3EZt8wn5M5N2eBNoMT/noPEnGHhSYBE2O4dJTMXZr2235KSHqSbCYiKFml5oFhjNo8dHDBIlbOYmbzSbb6yuh25NrxaU89Esrx/8To+ZbZeDLIbWB0aXTsNODgnSiIxII1EsAqdXLeyhXQ2pDwUqnmRJAapkWLgxbyz8tl7S0YfO5gIKSQhQBpBaFj8YQgEBqBJBaahUhHghAIIoAUovCR2MIQCA1AkgttYoQDwQgEEUAqUXhozEEIJAaAaSWWkWIBwIQiCKA1KLw0RgCEEiNAFJLrSLEAwEIRBFAalH4aAwBCKRGAKmlVhHigQAEogggtSh8NIYABFIjgNRSqwjxQAACUQSQWhQ+GkMAAqkRQGqpVYR4IACBKAJILQofjSEAgdQIILXUKkI8EIBAFAGkFoWPxhCAQGoEkFpqFSEeCEAgigBSi8JHYwhAIDUCSC21ihAPBCAQRQCpReGjMQQgkBoBpJZaRYgHAhCIIoDUovDRGAIQSI0AUkutIsQDAQhEEUBqUfhoDAEIpEYAqaVWEeKBAASiCCC1KHw0hgAEUiOA1FKrCPFAAAJRBJBaFD4aQwACqRFAaqlVhHggAIEoAkgtCh+NIQCB1AggtdQqQjwQgEAUAaQWhY/GEIBAagQktUetoJanFhjxQAACEBiAwJ+S2rethl8N0JgmEIAABFIj8J2ktqYV1Tetr4nW1+rUIiQeCEAAAn0QuNc6Z7L19fX/doZFDEYWe9MAAAAASUVORK5CYII=`;
  }
};
export const getConversationHistoryTime = (UTCTime = "") => {
  try {
    return moment.utc(UTCTime).local().format("h:mm a");
  } catch {
    return "--";
  }
};
export const getMessageTimeElement = (
    createdAt,
    message_type = "",
    editedStatus = 1,
    chatType,
    isUserMessage,
    msgStatus,
    favouriteStatus
) => {
    return (
        <div className={(message_type === "image") || (message_type === "video") || (message_type === "gif") ? "message-time" : ''}>
            <span className={isUserMessage ? "message-time-fromUser" : "message-time-toUser"}>
                <div className="msg-sent-time">
                    {(message_type !== "image") || (message_type !== "video") ? (
                        <>
                            <div>{getConversationHistoryTime(createdAt)}</div>
                        </>
                    ) : (
                        <>
                            <div>
                                {getConversationHistoryTime(createdAt)}
                            </div>
                        </>
                    )}
                </div>
            </span>
        </div>
    );
};

export const getInitials = (name = "") => {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
    }
    return words
        .slice(0, 2)
        .map(word => word[0])
        .join("")
        .toUpperCase();
};
export const getAvatarColor = (text = "") => {
    let hash = 0;

    for (let i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 50%)`;
};

export const chatUserIdsMatch = (idA, idB) => {
    if (!idA || !idB) return false;
    const a = String(idA);
    const b = String(idB);
    if (a === b) return true;
    const bareA = a.split("@")[0];
    const bareB = b.split("@")[0];
    return bareA === bareB;
};

export const resolveChatPartnerUserId = (chatSelectedMemberData, employeeUserId) => {
    if (!chatSelectedMemberData) return null;
    const { fromUserId, toUserId } = chatSelectedMemberData;
    if (!employeeUserId) return fromUserId;
    if (chatUserIdsMatch(fromUserId, employeeUserId)) return toUserId;
    if (chatUserIdsMatch(toUserId, employeeUserId)) return fromUserId;
    return fromUserId;
};

export const resolveEmployeeConversationUserId = ({
    messages = [],
    selectedMemberData = {},
    selectedUserId = null,
    selectedUserIdRecentChat = null,
    chatSelectedMemberData = null,
}) => {
    const openedEmployeeId = selectedMemberData?.userId
        || selectedUserId
        || selectedUserIdRecentChat
        || chatSelectedMemberData?.monitoredEmployeeId;

    if (!chatSelectedMemberData) return openedEmployeeId;

    const { fromUserId, toUserId } = chatSelectedMemberData;

    if (openedEmployeeId) {
        if (chatUserIdsMatch(toUserId, openedEmployeeId)) return toUserId;
        if (chatUserIdsMatch(fromUserId, openedEmployeeId)) return fromUserId;

        if (messages.length) {
            const senders = [...new Set(messages.map((m) => m.fromUserId).filter(Boolean))];
            const matchedSender = senders.find((s) => chatUserIdsMatch(s, openedEmployeeId));
            if (matchedSender) return matchedSender;
        }
    }

    return toUserId || fromUserId || openedEmployeeId;
};

export const isMessageFromSelectedEmployee = (messageFromUserId, employeeConversationUserId) => {
    if (!messageFromUserId || !employeeConversationUserId) return false;
    return chatUserIdsMatch(messageFromUserId, employeeConversationUserId);
};
